module.exports = __webpack_public_path__ + "img/Best of Rose.b7a824b4.jpg";